/* eslint-disable @typescript-eslint/naming-convention */
const authRoutes = {
  wellevate_practitioner_sign_up: "/wellevate/practitioner-signup",
  emerson_ecologics_practitioner_sign_up: "/emerson-ecologics/practitioner-signup",
  practitioner_sign_up: "/practitioner-signup",
  patient_sign_up: "/patient-signup",
  login: "/login",
  forgot_password: "/password",
  edit_password: "/edit_password",
  usApp: "https://us.fullscript.com",
  caApp: "https://ca.fullscript.com",
  rx_sign_in: "/welcome/:practitionerSlug/:tpSlug",
  rx_sign_in_forgot_password: (practitionerSlug = ":practitionerSlug", tpSlug = ":tpSlug") =>
    `/welcome/${practitionerSlug}/${tpSlug}/forgot-password`,
} as const;

export { authRoutes };
